import { Stack, styled, Typography } from "@tm/components"
import { Button } from "@tm/controls"
import { FastCalculator } from "@tm/data"
import { useLocalization } from "@tm/localization"

type Props = {
    item: FastCalculator.CalcInput
    hasHits?: boolean
    onClick: () => void
}

export default function CalcButtonTag({ item, onClick, hasHits }: Props) {
    const { translateText } = useLocalization()

    if (!item?.labelSegments?.length && !item?.label?.length) {
        return null
    }

    const renderSegments = item?.labelSegments?.length
        ? item.labelSegments!.map((labelSegment) => {
              const description = labelSegment.description.charAt(0).toUpperCase() + labelSegment.description.slice(1)
              const value = String(labelSegment.value).charAt(0).toUpperCase() + String(labelSegment.value).slice(1)

              return (
                  <Stack key={item.id + value} spacing={0.5} textAlign="left">
                      <Typography fontWeight={500} fontSize="12px">
                          {description}
                      </Typography>
                      <Typography fontWeight="bold" fontSize="12px">
                          {value}
                      </Typography>
                  </Stack>
              )
          })
        : [
              <StyledStack key={`${item.id}-label`}>
                  {item?.label === "..." ? (
                      <StyledHitsLabel hasHits={hasHits} skin={hasHits ? "highlight" : "default"}>
                          {translateText(14073).toUpperCase()}
                      </StyledHitsLabel>
                  ) : (
                      <Typography fontWeight={500} fontSize="12px">
                          {item.label!.charAt(0).toUpperCase() + item.label!.slice(1)}
                      </Typography>
                  )}
              </StyledStack>,
          ]

    return (
        <StyledButton onClick={onClick} size="s" key={item.id} layout={["holo"]} skin={item.isDisabled ? "primary" : undefined}>
            <Stack direction="row" spacing={2}>
                {renderSegments}
                {item?.labelSegments && item?.labelSegments?.length > 0 && (
                    <StyledTypography hasHits={hasHits} skin={hasHits ? "highlight" : "default"}>
                        {translateText(14073).toUpperCase()}
                    </StyledTypography>
                )}
            </Stack>
        </StyledButton>
    )
}

const StyledStack = styled(Stack)({
    textAlign: "left",
    minHeight: "40px",
    minWidth: "2em",
    justifyContent: "center",
    alignItems: "center",
    spacing: "0.5",
})

const StyledButton = styled(Button)({
    padding: ".5em",
    borderRadius: "3px",
    cursor: "pointer",
    margin: "0 .5em .5em 0",
    display: "inline-block",
})

const StyledTypography = styled(Typography)<{ hasHits?: boolean }>(({ theme, hasHits }) => ({
    position: "relative",
    height: "52px",
    padding: "0.5em",
    background: hasHits ? theme.palette.highlight.light : "transparent",
    borderLeft: hasHits ? `1px solid ${theme.palette.highlight.main}` : "1px solid #c3c3c3",
    fontSize: theme?.font?.label?.fontSize,
    alignContent: "center",
    "&&": {
        margin: "-6px -7px -6px 1em",
    },
}))

const StyledHitsLabel = styled(StyledTypography)({
    borderLeft: "none",
    "&&": {
        margin: "-6px -7px",
    },
})
